import React, { useEffect, useState } from "react";
import useWebSocket, { ReadyState } from "react-use-websocket";
import Cookies from "js-cookie";
import jwt_decode from "jwt-decode";

export default function Test() {
  let token = Cookies.get("access_token");
  let  decoded = jwt_decode(token);
  const [welcomeMessage, setWelcomeMessage] = useState("");
  const [messageHistory, setMessageHistory] = useState ([]);
  const [message, setMessage] = useState("");
  const [name, setName] = useState(decoded?.username);

  const { readyState, sendJsonMessage } = useWebSocket(`ws://buyduy-user.cstdev.live/ws/chat/8013b8a5-1c13-4fd1-a673-3edc3c4d1604/?token=${token}`, {
    onOpen: () => {
      console.log("Connected!");
    },
    onClose: () => {
      console.log("Disconnected!");
    },
    // onMessage handler
    onMessage: (e) => {
      console.log(e, 'event')
      console.log(e.data, 'data')

      const data = JSON.parse(e.data);
      switch (data.type) {
        case "welcome_message":
          setWelcomeMessage(data.message);
          break;
        case "chat_message_echo":
          setMessageHistory((prev) => prev.concat(data));
          break;
        default:
          console.error("Unknown message type!");
          break;
      }
    }
  });

  const connectionStatus = {
    [ReadyState.CONNECTING]: "Connecting",
    [ReadyState.OPEN]: "Open",
    [ReadyState.CLOSING]: "Closing",
    [ReadyState.CLOSED]: "Closed",
    [ReadyState.UNINSTANTIATED]: "Uninstantiated"
  }[readyState];

  function handleChangeMessage(e) {
    setMessage(e.target.value);
  }

  useEffect(()=>{
    setName("Regional admin")
  },[])
  function handleChangeName(e) {
    setName(e.target.value);
  }

  const handleSubmit = () => {
    sendJsonMessage({
      type: "chat_message",
      message,
      name
    });
    setName("");
    setMessage("");
  };

  console.log(decoded.username, 'name')

  console.log(decoded)

  return (
    <div>
      <span>The WebSocket is currently {connectionStatus}</span>
      <p>{welcomeMessage}</p>
      <input
        name="name"
        placeholder="Name"
        onChange={handleChangeName}
        value={name}
        className="shadow-sm sm:text-sm border-gray-300 bg-gray-100 rounded-md"
      />
      <input
        name="message"
        placeholder="Message"
        onChange={handleChangeMessage}
        value={message}
        className="ml-2 shadow-sm sm:text-sm border-gray-300 bg-gray-100 rounded-md"
      />
      <button className="ml-3 bg-gray-300 px-3 py-1" onClick={handleSubmit}>
        Submit
      </button>
      <hr />
      <ul>
        {messageHistory.map((message, index) => (
          <div className="border border-gray-200 py-3 px-3" key={index}>
            {message.name}: {message.message}
          </div>
        ))}
      </ul>
    </div>
  );
}